module.exports = __webpack_public_path__ + "img/informacoes.25a282cb.svg";